

import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AngularFireDatabase} from '@angular/fire/database';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import {map, keys} from 'lodash';

@Component({
  selector: 'app-invitations',
  templateUrl: './invitations.component.html',
  styleUrls: ['./invitations.component.css']
})
export class InvitationsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() org: string;
  @Input() name: string;
  @Input() orgName: string;
  @Input() entityId: string;
  @Input() showAddButton: boolean;
  @Input() superAdmin: boolean;

  instructors;

  leaving =  new Subject()
  displayedColumns: string[] = ['email','entityId','response', 'errors'];
  invitations;
  responses = {}
  change = new Subject()
  constructor(
    public dialog: MatDialog,
    private db: AngularFireDatabase 
    ) { }

  ngOnInit(): void {
    this.setup()
  }

  setup = () => {
    if (!this.org) { return }

    this.db.object(`Invitations/${this.org}`).valueChanges()
    .takeUntil(this.leaving)
    .takeUntil(this.change)
    .subscribe(invites => {
      const invitations = map(keys(invites), key => { return {...invites[key], id: key}})
      this.invitations = new MatTableDataSource(invitations)
    })

    this.db.object(`InvitationResponses/${this.org}`).valueChanges()
    .takeUntil(this.leaving)
    .takeUntil(this.change)
    .subscribe(resp => {
        this.responses = resp
    })
  }

  ngOnChanges(change){
    this.change.next()
    this.setup()
  }


  ngOnDestroy(): void {
    this.leaving.next(null)
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.invitations.filter = filterValue.trim().toLowerCase();
  }

}


